import { createAsyncThunk } from '@reduxjs/toolkit';
import { GROUP_NAME, ThunkApi, User } from '@greenkub-fronts/shared/interface';

type LoginRequest = {
  userId: string;
};

type LoginResponse = {
  email: string;
  token: string;
  profile: User;
};

export const loginAsUser = createAsyncThunk<
  LoginResponse,
  LoginRequest,
  ThunkApi
>(
  'loginAsUser',
  async (
    data,
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    const newToken = await dispatch(
      extra.apiSlice.endpoints.getCustomerToken.initiate({
        userId: data.userId,
      })
    );

    const profileResp = await dispatch(
      extra.apiSlice.endpoints.getUserById.initiate(
        {
          userId: data.userId,
          groupName: GROUP_NAME.PROFILE,
        },
        { forceRefetch: true }
      )
    );

    const { email, token, user } = getState().auth;

    localStorage.setItem(
      'auth-callback',
      JSON.stringify({
        email: email,
        token: token,
        user: user,
      })
    );

    localStorage.removeItem('auth');
    localStorage.setItem(
      'auth',
      JSON.stringify({
        email: profileResp.data.email,
        token: newToken.data,
        user: profileResp.data,
      })
    );

    return {
      email: profileResp.data.email,
      token: newToken.data,
      profile: profileResp.data,
    } as LoginResponse;
  }
);
